// extracted by mini-css-extract-plugin
module.exports = {"container":"RateModal_container__3qqPc","flexCurt":"RateModal_flexCurt__3DGne","curt":"RateModal_curt__28iho"};